// extracted by mini-css-extract-plugin
module.exports = {"modal":"FileBrowserModal-modal-2BpgF Modal-modal-3R_Xg"};